import { useScopeUrl } from '@/hooks/use-scope-url';
import { useStatusAvailabilityStore } from '@/stores/status-availability';

/** Subscribe to visibility without initiating a status fetch. */
const useStatusUnavailable = (id?: string) => {
  const scope = useScopeUrl();
  return useStatusAvailabilityStore(
    (state) => !!(id && (state.unavailable[scope]?.[id] || state.deleted[scope]?.[id])),
  );
};

export { useStatusUnavailable };
